<template>
  <div>
    <md-dialog :md-active.sync="showDialog" :md-backdrop="false">
    <md-dialog-title>{{ $t('errorTitle') }}</md-dialog-title>

    <md-dialog-content>
      <div class="md-layout">
        <div class="md-layout-item">
          {{message}}
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">{{ $t('popinClose') }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import EventBus from '../eventBus';
export default {
  name: 'ESError',
  data: function data() {
    return {
      message: '',
      showDialog: false,
    }
  },
  mounted: function() {
    EventBus.$on('error-message', this.errorMessage);
  },
  methods: {
    errorMessage: function(message) {
      this.showDialog = true;
      this.message = message;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Error.vue